import { ReviewApi } from '@/api'
import { configuration } from '@/lib/api'

export const reviewApi = new ReviewApi(configuration)
